<template>
  <div v-if="ready" style="width: 100%;display: flex;align-items: center;" class="s-select">

    <div v-if="viewMode" v-html="selectedOptions"></div>
    <el-select
        class="s-select"
        :class="(large)?'largefit':''"
        style="width: 100%"
        :placeholder="placeholder"
        v-else
        v-model="cvalue"
        ref="sselector"
        :allow-create="allowCreate"
        :filterable="filterable||allowCreate"
        :clearable="clearable||allowCreate"
        :multiple="multiple"
        @change="refocus"
    >
      <el-option
          v-for="item in selectOptions"
          :key="item[valueProp]"
          :label="firstCapital(item[labelProp])"
          :value="item[valueProp]"
          v-html="parseOption(item)"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
// import mdl from "~/mixins/mdl";
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";

export default {
  name: "s-select",
  data() {
    return {
      cvalue: null,
      ready: false
    };
  },
  props: {
    loadRepo: {type: Boolean, default: false},
    large: {type: Boolean, default: false},
    viewMode: {type: Boolean, default: false},
    optionsRepo: {default: null},
    autocompleteModel: {default: null},
    focusthis: {default: false},
    filterable: {default: false},
    clearable: {default: true},
    multiple: {default: false},
    allowCreate: {type: Boolean, default: false},
    // ref: { default: null },
    options: {default: null},
    value: {default: null},
    keField: {type: String, default: "id"},
    classModel: {type: String, default: null},
    placeholder: {type: String, default: "..."},
    labelProp: {default: "label"},
    valueProp: {default: "value"}
  },
  watch: {
    value(val, oldval) {
      if (val != this.cvalue && val != oldval) {
        this.cvalue = val + "";
      }
    },
    cvalue(val, oldval) {
      _log_("vhann....", val, oldval);
      // if (!val && !oldval) return;
      if (val != this.value && val != oldval) {
        if (val && this.allowCreate && this.wOptionsRepo) {
          const r = this.getList(this.wOptionsRepo);
          let q = {}
          q[this.valueProp] = val
          if (!this.findInArray(r, q)) {
            let newRepo = [...r], newVal = {}
            newVal[this.valueProp] = val
            newVal[this.labelProp] = val
            r.push(newVal)
            this.$store.commit('tags/setlist', {type: this.wOptionsRepo, list: newRepo})
          }
        }
        this.$emit("input", val);
        this.$emit("change", {val: val, oldval: oldval});
      } //{val:val,oldval:oldval})
    }
  },
  computed: {
    wOptionsRepo() {
      if (this.autocompleteModel)
        return this.autocompleteModel + ':' + this.valueProp
      return this.optionsRepo
    },
    ...mapGetters({
      getList: "tags/getList"
    }),
    selectOptions() {
      if (this.wOptionsRepo) {
        const r = this.getList(this.wOptionsRepo);
        if (this.valueProp == "raw") {
          var rr = [];
          r.forEach(element => {
            rr.push({label: element, raw: element});
          });
          return rr;
        }
        // _log_("change options????" + this.wOptionsRepo, r);
        return r;
      }
      // _log_("change options????", this.options);
      return this.options;
    },
    selectedOptions() {
      _log_("find sel." + this.cvalue, this.wOptionsRepo);
      if (!this.cvalue || this.cvalue == "" || this.cvalue == 0)
        return "&nbsp;";
      if (this.valueProp == "raw") return this.cvalue;
      var avOptions = null;
      if (this.wOptionsRepo) {
        avOptions = this.getList(this.wOptionsRepo);
      }
      // THEDC.repoDB[this.wOptionsRepo];
      else avOptions = this.options;
      // _log_("find sel."+this.wOptionsRepo, avOptions,q);
      var q = {};
      q[this.valueProp] = this.cvalue + "";
      var o = _.find(avOptions, q);
      if (o) return o[this.labelProp];
      else {
        q[this.valueProp] = this.cvalue;
        o = _.find(avOptions, q);
        if (o) return o[this.labelProp];
      }
      return "?" + this.cvalue;
    }
  },
  async created() {
    // _log_("change sel.", this.wOptionsRepo);
    //
    // if (this.wOptionsRepo && this.loadRepo) {
    //   const r = await this.fetch(this.wOptionsRepo);
    // }

    // _log_("success sel.", this.wOptionsRepo);
    if (this.value) this.cvalue = this.value + "";
  },
  methods: {
    ...mapActions({
      fetch: "tags/fetch",
      fetchAllOptions: "tags/fetchAll"
    }),
    parseOption(item) {
      return this.firstCapital(item[this.labelProp])
    },
    refocus() {
      let vm = this;

      let elel = this.$el; // vm.$refs['sselector']
      // if (elel) elel[0].focus()
      // _log_("change sel.", elel);
      //  elel.focus();
      let inputs = elel.getElementsByTagName("input");
      // let elel = vm.$refs['col_input' + rowScope.column.property]
      // // if (elel) elel[0].focus()
      // _log_('is ins..F.' + colIndex, elel[0])
      inputs[0].focus();
    }
  },
  async mounted() {
    let vm = this;
    if (this.wOptionsRepo) {
      if (!this.getList(this.wOptionsRepo))
        await this.fetchAllOptions([this.wOptionsRepo]);
      _log_("find sel.this.wOptionsRepo.SO.", this.wOptionsRepo, this.getList(this.wOptionsRepo));
    }
    if (this.focusthis) {
      Vue.nextTick(function () {
        let elel = vm.$refs["sselector"];
        // if (elel) elel[0].focus()
        // _log_("is insCCC..F.", elel);
        elel.focus();
        let inputs = elel.$el.getElementsByTagName("input");
        // let elel = vm.$refs['col_input' + rowScope.column.property]
        // // if (elel) elel[0].focus()
        // _log_('is ins..F.' + colIndex, elel[0])
        inputs[0].focus();
      });
    }
    this.ready = true;
  }
};
</script>

<style>
.el-select-dropdown__item span:before {
  position: relative;
  margin-left: -14px;
  margin-right: 4px;
  padding: 2px;
  font-size: 1.2em;
  text-shadow: 0px 0px 2px;
  color: green;
  font-weight: bold;
  content: '+';
}

.largefit .el-input__inner {
  height: auto !important;
  line-height: 42px !important;
}

.largefit .el-input--suffix .el-input__inner {
  padding-right: auto !important;
}
</style>
